<script setup lang="ts">
const { session, clear } = useUserSession();
const ended = ref(false);

const impersonated = computed(() => !!(session.value as any)?.impersonated);
const name = computed(() => (session.value as any)?.user?.name || "candidate");

async function exit() {
  await clear();
  ended.value = true;
}
</script>

<template>
  <div
    v-if="ended"
    class="flex items-center justify-center gap-2 bg-slate-800 px-4 py-2 text-[13px] text-white"
  >
    Impersonation ended — you can close this tab.
  </div>
  <div
    v-else-if="impersonated"
    class="flex items-center gap-3 bg-amber-500/20 px-4 py-2 text-[13px] text-amber-950"
  >
    <span class="font-semibold uppercase tracking-wide text-amber-700">Admin preview</span>
    <span class="min-w-0 flex-1 truncate">
      You are viewing the candidate experience as <strong>{{ name }}</strong>. Changes are saved to their record.
    </span>
    <button
      type="button"
      class="shrink-0 rounded-md border border-amber-600/40 bg-white/60 px-2.5 py-1 font-medium text-amber-900 hover:bg-white"
      @click="exit"
    >
      Exit
    </button>
  </div>
</template>
